function getEventObject(id, value) {
    return { target: { id, value } };
}

module.exports = {
    getEventObject
}
